module.exports = __webpack_public_path__ + "img/图5.2e2ffbec.png";